import { getStack } from '@/lib/contentstack/stack';
import { getBundleOfferProduct, getProductByID } from '@/lib/shopify';
import BundleOffer from './BundleOffer';
import offsetBlockClass from '@/utils/offsetBlockClass';

export default async function BundleOfferData({ block, position }) {
  const { _metadata, reference } = block?.bundle_offer;
  const data = await fetchData(
    reference[0]._content_type_uid,
    reference[0].uid
  );
  const hasOffsetBlockSelect = !!data?.show_offset_block_selector;
  return hasOffsetBlockSelect ? (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name="bundle-offer"
      className={offsetBlockClass(
        data?.show_offset_block_selector,
        'scroll-mt-[75px] not-last:mb-8 sm:scroll-mt-[65px]'
      )}
    >
      <div
        id={`${_metadata.uid}_${position}`}
        data-name="bundle-offer"
        className="bg-parlor-green-10 rounded-[4px] p-4 text-black"
      >
        <BundleOffer data={data} />
      </div>
    </section>
  ) : (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name="bundle-offer"
      className="bg-parlor-green-10 rounded-[4px] p-4 text-black not-last:mb-8"
    >
      <BundleOffer data={data} />
    </section>
  );
}
async function fetchData(_content_type_uid, uid) {
  const Stack = getStack();
  const query = Stack.ContentType(_content_type_uid)
    .Entry(uid)
    .addParam('include_dimension', 'true');
  const entry = await query.toJSON().fetch();

  // This is a special product that holds helpful metadata for us.
  let bundleOfferShopifyData = await getBundleOfferProduct(
    `gid://shopify/Product/${entry.ecommerce_product_id}`
  );
  bundleOfferShopifyData = {
    ...JSON?.parse(bundleOfferShopifyData?.bundleOfferPriceData?.value)
  };
  const products = await Promise.all(
    entry.products?.map(async (product) => {
      const productReference = await fetchReference(
        product.reference[0]._content_type_uid,
        product.reference[0].uid
      );
      const shopifyProduct = await getProductByID(
        `gid://shopify/Product/${productReference.product_id}`
      );
      return {
        product_description: product.product_description,
        product_tabs: productReference.product_description,
        shopifyProduct: shopifyProduct,
        variants_out_of_stock: product.variants_out_of_stock
      };
    })
  );

  const data = {
    discount_message: entry.discount_message,
    display_title: entry.display_title,
    title: entry.title,
    show_offset_block_selector: entry.show_offset_block_selector,
    products: products,
    bundleOfferShopifyData,
    uid: entry.uid
  };

  return data;
}

async function fetchReference(_content_type_uid, uid) {
  const Stack = getStack();
  try {
    const query = Stack.ContentType(_content_type_uid)
      .Entry(uid)
      .addParam('include_dimension', 'true');
    const response = await query.toJSON().fetch();
    const entry = {
      title: response.title,
      product_id: response.product_id,
      product_description: response?.product_detail_blocks.find((block) =>
        block.hasOwnProperty('product_description')
      )
    };

    return entry;
  } catch (error) {
    console.error(
      `Error fetching content for UID: ${uid}, content type: ${_content_type_uid}`,
      error
    );
    return null;
  }
}
